module.exports = __webpack_public_path__ + "img/加入团队.a7e9b0de.svg";